import { Hex, sliceHex } from 'viem';

export function getInputDataUrl(inputHash: Hex): string {
  return `${process.env.NEXT_PUBLIC_DA_URL ?? ''}${sliceHex(inputHash, 1)}`;
}
